import { FC, JSX, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "antd";
import Loader from "../../loader/Loader";
import "./PageRoutes.style.scss";

import Home from "../../../../pages/home/Home";
const AboutPage = lazy(() => import("../../../../pages/about/AboutPage"));
const Career = lazy(() => import("../../../../pages/career/Career"));
const WebDevelopment = lazy(() => import("../../../../pages/services/webDevelopment/WebDevelopment"));
const ContactPage = lazy(() => import("../../../../pages/contact/ContactPage"));
const WorkWithYouPage = lazy(() => import("../../../../pages/work-with-you/WorkWithYouPage"));
const UiUxDesign = lazy(() => import("../../../../pages/services/ui-ux-design/UiUxDesign"));
const ProductDevelopment = lazy(() => import("../../../../pages/services/product-development/ProductDevelopment"));
const Portfolio = lazy(() => import("../../../../pages/portfolio/Portfolio"));

interface RouteKey {
  path: string;
  element: JSX.Element;
}

interface IRoute {
  [key: string]: RouteKey;
}

// Wrapper component for lazy-loaded routes with Suspense
const LazyRouteWrapper: FC<{ children: JSX.Element }> = ({ children }) => (
  <Suspense
    fallback={
      <div className="loader-wrapper">
        <Loader />
      </div>
    }
  >
    {children}
  </Suspense>
);

export const PageRoutesConstant: IRoute = {
  Home: {
    path: "/",
    element: <Home />,
  },
  About: {
    path: "/about",
    element: (
      <LazyRouteWrapper>
        <AboutPage />
      </LazyRouteWrapper>
    ),
  },
  Career: {
    path: "/career",
    element: (
      <LazyRouteWrapper>
        <Career />
      </LazyRouteWrapper>
    ),
  },
  WebDevelopment: {
    path: "/services/web-development",
    element: (
      <LazyRouteWrapper>
        <WebDevelopment />
      </LazyRouteWrapper>
    ),
  },
  ProductDevelopment: {
    path: "/services/product-development",
    element: (
      <LazyRouteWrapper>
        <ProductDevelopment />
      </LazyRouteWrapper>
    ),
  },
  UiUxDesign: {
    path: "/services/ui-ux-design",
    element: (
      <LazyRouteWrapper>
        <UiUxDesign />
      </LazyRouteWrapper>
    ),
  },
  Portfolio: {
    path: "/portfolio",
    element: (
      <LazyRouteWrapper>
        <Portfolio />
      </LazyRouteWrapper>
    ),
  },
  Contact: {
    path: "/contact",
    element: (
      <LazyRouteWrapper>
        <ContactPage />
      </LazyRouteWrapper>
    ),
  },
  WorkWithYou: {
    path: "/hire-us",
    element: (
      <LazyRouteWrapper>
        <WorkWithYouPage />
      </LazyRouteWrapper>
    ),
  },
  NotFound: {
    path: "*",
    element: <Navigate to="/" />,
  },
};

const PageRoutes: FC = () => {
  return (
    <Layout>
      <Routes>
        {Object.keys(PageRoutesConstant).map((key) => {
          const pageItem = PageRoutesConstant[key];
          return (
            <Route key={key} path={pageItem.path} element={pageItem.element} />
          );
        })}
      </Routes>
    </Layout>
  );
};

export default PageRoutes;
